import { useTachDocWorkflow } from "../../../../context/TachDocumentContext";
import { StyledFormCheck } from "../../../../styles/MainStyles";
import {
    StyledCheckboxFlexDiv,
    StyledCheckboxText,
} from "../../../../styles/pages/Workflows/InformationTach";

const CheckboxTach = () => {
    const { check, setCheck } = useTachDocWorkflow();
    return (
        <StyledCheckboxFlexDiv>
            <StyledFormCheck
                type="checkbox"
                width={16}
                height={16}
                color="2px solid #787878"
                checked={check}
                onChange={() => setCheck(!check)}
            />
            <StyledCheckboxText>
                Estou ciente das atividades atribuídas no TACH do professor.
            </StyledCheckboxText>
        </StyledCheckboxFlexDiv>
    );
};

export default CheckboxTach;
